import React from 'react';
import Icon from '../../../components/AppIcon';

const CompanyStory = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="space-y-4">
              <h2 className="text-3xl font-bold text-text-primary">
                From Traditional Contractor to Strategic Technology Partner
              </h2>
              <p className="text-lg text-text-secondary leading-relaxed">
                Founded in 2015, Xtreem Fibre Solutions began as a telecommunications contractor with a vision to transform how businesses approach connectivity infrastructure. What started as a small team of certified technicians has evolved into the region's premier fiber optic transformation partner.
              </p>
            </div>
            
            <div className="space-y-4">
              <p className="text-text-secondary leading-relaxed">
                Our journey reflects the telecommunications industry's evolution from legacy copper systems to future-ready fiber infrastructure. We've successfully completed over 500 enterprise installations, helping businesses unlock their digital potential through superior connectivity solutions.
              </p>
              
              <p className="text-text-secondary leading-relaxed">
                Today, we're not just installers—we're strategic technology enablers who understand that every fiber optic project is ultimately about empowering business transformation and growth.
              </p>
            </div>
            
            <div className="grid grid-cols-2 gap-6 pt-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-primary">500+</div>
                <div className="text-sm text-text-secondary">Projects Completed</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-primary">8+</div>
                <div className="text-sm text-text-secondary">Years Experience</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="aspect-square rounded-2xl overflow-hidden shadow-brand-strong">
              <img
                src="https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=600&h=600&fit=crop"
                alt="Xtreem Fibre Solutions team working on fiber optic installation"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-accent text-white p-4 rounded-xl shadow-brand-strong">
              <Icon name="Award" size={32} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyStory;